module.exports = __webpack_public_path__ + "static/media/header-375.dac0fdc5.webp";